// 발행기간 시작일~종료일 입력 (C410·C420 공용). 월 경계·역전은 PRD §2.7.2 규칙으로 보정하고 안내한다.
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { clampDateRange } from './issue-period';

export function DateRangeInputs({
  start,
  end,
  onChange,
}: {
  start: string;
  end: string;
  onChange: (start: string, end: string) => void;
}) {
  const { toast } = useToast();
  const change = (changed: 'start' | 'end', value: string) => {
    const next = clampDateRange(
      changed === 'start' ? value : start,
      changed === 'end' ? value : end,
      changed
    );
    onChange(next.start, next.end);
    if (next.message) toast({ title: next.message });
  };
  return (
    <div className='flex items-center gap-2'>
      <Input
        type='date'
        value={start}
        onChange={e => change('start', e.target.value)}
        inputSize='sm'
        className='w-40'
      />
      <span className='text-muted-foreground'>~</span>
      <Input
        type='date'
        value={end}
        onChange={e => change('end', e.target.value)}
        inputSize='sm'
        className='w-40'
      />
    </div>
  );
}
